import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

import {BaseComponent} from 'iui-iconectiv-lib';
import {Tier} from "../model";

@Component({
  selector: 'custom-fee-schedule',
  templateUrl: './custom-fee-schedule.component.html',
  styleUrls: ['./custom-fee-schedule.component.scss'],
})


export class CustomFeeScheduleComponent extends BaseComponent implements OnInit {
  @Input() disabled: boolean = false;

  @Input() customTier: Tier;
  @Output() customTierChange: EventEmitter<Tier> = new EventEmitter<Tier>();

  @Input() tierConfirmRequired: boolean = false;
  @Output() tierConfirmed: EventEmitter<any> = new EventEmitter();

  headers: any[];

  constructor() {
    super();

    this.headers = [
      {header: 'Monthly Fee', width: '33'},
      {header: 'Lookup Allowance', width: '33'},
      {header: 'Overage Charge', width: '33'},
    ];
  }

  ngOnInit(): void {
    if (!this.customTier) {
      this.customTier = new Tier();
    }
  }

  onTierChange(tier: Tier) {
    this.customTierChange.emit(tier);
  }

  onTierConfirm() {
    this.tierConfirmed.emit(null);
  }
}
